import { InferType, object } from 'yup';
import { email } from '@app/utils/yup.utils';

export const InviteUserSchema = object({
  email: email(),
});

export type InviteUserSchema = InferType<typeof InviteUserSchema>;
